import React from 'react'

export default function FaceFeature({ scaleX, fill, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`} fill="none">
      <path
        d="M29.68 1.90991H28.67H1.27002L3.64001 40.88C3.64001 40.88 13.25 54.7699 29.18 48.6699C45.11 54.7799 54.72 40.88 54.72 40.88L57.09 1.90991H29.68Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
    </g>
  )
}
